/**
 * A token provided by the redirection context API
 */
export class RedirectionContextToken {
    /**
     * The token to use to authenticate
     */
    access_token: string;
    /**
     * The type of token
     */
    token_type: string;
    /**
     * When the token expires (when it was generated)
     */
    expires_in: number;
    /**
     * A token required to refresh access token.
     */
    validation_token: string;
}
